import { connect } from 'react-redux';

import { SessionUserSelectors } from '~selectors/SessionInfoSelectors';
import { selectContentTotalLength } from '~src/spacesPlatform/selectors/ContentSelectors';
import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';

import { AppState } from '../../app/state/AppState';
import { MapStateToProps } from '../../app/utils/ConnectUtils';
import { AllCollectionsSpace, AllCollectionsSpaceOwnProps, AllCollectionsSpaceStateProps } from './AllCollectionsSpace';

const mapStateToProps: MapStateToProps<AllCollectionsSpaceStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
  numberOfFetchedCollections: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,
  userDisplayName: SessionUserSelectors.sessionUserDisplayName(state)
});

export const ConnectedAllCollectionsSpace: React.ComponentClass<AllCollectionsSpaceOwnProps>
  = connect(mapStateToProps)(AllCollectionsSpace);
